import { CPopTemplateStyles } from '../model/c-pop-template-styles.model';

export function applyStyles(el: HTMLElement, styles: CPopTemplateStyles): void {
    try {
        Object.entries(styles).forEach(([key, value]) => {
            (el.style as any)[key] = value;
        });
    } catch {
        // nothing
    }
}
